// Services/PeerInitSyncManager.js
import PeerConnectionManager from "./PeerConnectionManager";
import { getData, saveData } from "../db/db_helper"; // Pfad anpassen
import { emitDbChange, dbEvents } from "../db/dbEvents";

let initialized = false;
let hasRequestedInit = false;

const BATCH_SIZE = 10;

function chunkArray(arr, size) {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
    }
    return chunks;
}

async function hostDataResponse(type, store, clientId, requestId, objectData) {
    if (type === "get") {
        const data = await getData(store);

        if (!Array.isArray(data)) {
            PeerConnectionManager.send(
                { type: "get_response", store, data, requestId },
                clientId
            );
            return;
        }

        const batches = chunkArray(data, BATCH_SIZE);
        const totalBatches = batches.length || 1;

        if (batches.length === 0) {
            PeerConnectionManager.send(
                { type: "get_response", store, data: [], requestId, batchIndex: 0, totalBatches: 1 },
                clientId
            );
            return;
        }

        batches.forEach((chunk, index) => {
            PeerConnectionManager.send(
                {
                    type: "get_response",
                    store,
                    data: chunk,
                    requestId,
                    batchIndex: index,
                    totalBatches,
                },
                clientId
            );
        });
    }
    if (type === "save") {
        await saveData(store, objectData)
    }

}

function handleMessage({ clientId, data } = {}) {
    if (!data || !data.type) return;

    if (PeerConnectionManager.isHost) {
        if (!data.store) return;
        hostDataResponse(data.type, data.store, clientId, data.requestId, data.data);
        return;
    }

    if (data.type === "trigger_reload") {
        emitDbChange(data.store);
    }
    if (data.type === "user") {
        localStorage.setItem("user", data.data);
        localStorage.setItem("workspaceIndex", data.ws);
    }
}

// App level Subsription to Listen to updates
export function initPeerInitSync() {
    if (initialized) return;
    initialized = true;

    PeerConnectionManager.onMessage(handleMessage);

    // Host: sobald ein neuer Client verbunden ist -> User-Objekt direkt senden
    PeerConnectionManager.onClientConnected((clientId) => {
        const user = localStorage.getItem("user");
        const ws = localStorage.getItem("workspaceIndex");

        PeerConnectionManager.send(
            { type: "user", data: user, ws },
            clientId
        );
    });

    PeerConnectionManager.subscribe((status) => {
        const connected = status === "connected";

        if (connected && !PeerConnectionManager.isHost && !hasRequestedInit) {
            hasRequestedInit = true;
        }

        if (!connected) {
            hasRequestedInit = false;
        }
    });
}